import styled from '@emotion/styled'

export const PeriodModeTogglerWrapper = styled.div``
